<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == `${to.meta.abrev}-empresa`) {
            next({ name: `${to.meta.abrev}-empresa-list`, replace: true });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == `${this.$route.meta.abrev}-empresa`) {
            this.$router.replace({ name: `${this.$route.meta.abrev}-empresa-list` });
        }
    },
};
</script>
